

















import { Vue, Component } from 'vue-property-decorator';
import * as config from './config';
import { List } from 'vant';
import { typeList, userHelper } from './api/index';
import ListItem from './components/ListItem.vue';
import { appShare, wxShareInfo } from '@/common/ts/common';
Vue.use(List);
@Component({
  components: {
    ListItem,
  },
})
export default class ListPage extends Vue {
  option = config.OPTHINES;
  List: any[] = [];
  type: any;
  loading = false;
  finished = false;
  page = 1;
  loadingStatus = true;
  title = '';

  created() {
    // this.fetchList();
    this.type = this.$route.query.type;
    if (this.type === '1') {
      this.title = '小学组最新投稿';
    } else if (this.type === '2') {
      this.title = '中学组最新投稿';
    } else {
      this.title = '大学组最新投稿';
    }
    userHelper().then((res) => console.log('访问userHelper'));
    // 分享
    appShare({
      title: '人和街小学四年级（2016级）“我十岁啦”作文展',
      url: window.location.href,
      subtitle: '人和街小学四年级（2016级）“我十岁啦”作文展',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '人和街小学四年级（2016级）“我十岁啦”作文展',
      subtitle: '人和街小学四年级（2016级）“我十岁啦”作文展',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  onLoad() {
    typeList(this.type, this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.List = [...this.List, ...res.data];
    }
    this.loading = false;
  }
}
